import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";

import { Query } from "react-apollo";
import { addToDataLayerGTM } from "../../utils/addToDataLayerGTM";

import dimensionCard from "../../assets/img/dimensionCard.png";
import banner_default from "../../assets/img/portoEduc_Bn_Cursos_Online.jpg";
import Config from "../../config/config";

import CourseCard from "../../components/CourseCard";
import SearchNotFound from "../../components/SearchNotFound";
import Paginator from "../../components/Paginator";
import Categories from "../../components/CategoriesButtons";
import { AllCards } from "../../components/Skeleton";
import ErrorModal from "../../components/Modal/ErrorModal";
import "./Courses.css";

import {
  dam_client,
  lms_client,
  GET_CURSES,
  GET_CATEGORIES,
  GET_SUBCATEGORIES,
  GET_COURSE_HAS_USER_ITEM,
  QUERY_QUANTIDADE_CURSOS,
  GET_CATEGORY
} from "./apollo";

class Courses extends Component {
  constructor() {
    super();
    this.state = {
      page: 1,
      limit: 6,
      totalCourses: 0
    };
    this.imgref = React.createRef();
  }

  resetPage() {
    this.setState({ page: 1 });
  }

  quantidadeCursos() {
    lms_client
      .query({
        query: QUERY_QUANTIDADE_CURSOS,
        variables: { category_id: this.category_id }
      })
      .then(result =>
        this.setState({ totalCourses: result.data.courses_count.count })
      );
  }

  componentDidMount() {
    this.quantidadeCursos();
    if (this.props.match.path === "/cursos-online") {
      // Google Tag Manager
      const dataLayer = {
        event: "step_change",
        etapa: "/cursos/online/"
      };
      addToDataLayerGTM(dataLayer);
    }
  }

  handleClickSubCategoriesGTM(category, subCategory) {
    // Google Tag Manager
    const dataLayer = {
      event: "step_change",
      etapa: `/cursos/online/${category}/${subCategory}`
    };
    addToDataLayerGTM(dataLayer);

    this.resetPage();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.match.params.category_id !== this.props.match.params.category_id
    ) {
      this.quantidadeCursos(this.props.match.params.category_id);
    }
  }

  render() {
    this.category_id = this.props.match.params.category_id
      ? this.props.match.params.category_id
      : 0;
    return (
      <div>
        <Query
          client={dam_client}
          query={GET_CATEGORY}
          variables={{ category_id: this.category_id }}
        >
          {({ loading, error, data }) => {
            if (loading) return <div>Carregando...</div>;
            if (error) {
              // Google Tag Manager
              addToDataLayerGTM({
                event: "erro",
                etapa: "erro ao buscar a categoria"
              });
              return <ErrorModal />;
            }

            return (
              <img
                className="banner_content"
                src={
                  data.category && data.category.banner
                    ? Config.baseUrl + "/dam/assets/" + data.category.banner
                    : banner_default
                }
              />
            );
          }}
        </Query>
        <div className="content">
          <div className="container">
            <Categories
              handleClickSubCategoriesGTM={this.handleClickSubCategoriesGTM.bind(
                this
              )}
              client={dam_client}
              category={GET_CATEGORIES}
              subcategory={GET_SUBCATEGORIES}
              href={"/#/cursos-online/"}
            />

            <Query
              client={lms_client}
              query={GET_CURSES}
              variables={{
                category_id: this.category_id,
                limit: this.state.limit,
                page: this.state.page
              }}
            >
              {({ loading, error, data }) => {
                if (loading)
                  return (
                    <AllCards>
                      <img ref={this.imgref} src={dimensionCard} />
                    </AllCards>
                  );
                if (error) {
                  // Google Tag Manager
                  addToDataLayerGTM({
                    event: "erro",
                    descricao: "erro ao buscar os cursos"
                  });
                  return <ErrorModal />;
                }

                if (
                  !data.courses_collections ||
                  !data.courses_collections.courses.length
                ) {
                  return (
                    <SearchNotFound
                      onClick={() => (window.location.href = "/#/home")}
                      buttonMessage="Voltar a página inicial"
                    />
                  );
                }
                let course_by_rows = [];
                let i = 1;
                let ii = 1;
                data.courses_collections.courses.forEach(item => {
                  if (!course_by_rows[i]) {
                    course_by_rows[i] = [];
                  }
                  course_by_rows[i].push(item);
                  if (ii++ === 3) {
                    ii = 1;
                    i++;
                  }
                });
                return course_by_rows.map((itens, index) => (
                  <Row key={index}>
                    {itens.map(item => (
                      <Col key={item.id} md={4}>
                        <CourseCard
                          key={`couse_${item.id}`}
                          min={
                            this.imgref.current
                              ? this.imgref.current.height
                              : ""
                          }
                          item={item}
                          href={"/#/curso/" + item.id}
                          client={lms_client}
                          variables={{ course_id: item.id, course_trails:true }}
                          userQuery={GET_COURSE_HAS_USER_ITEM}
                          src={Config.baseUrl + "/lms/assets/" + item.thumbnail}
                          type={"course"}
                        />
                      </Col>
                    ))}
                  </Row>
                ));
              }}
            </Query>

            <Col>
              <Paginator
                currentPage={this.state.page}
                pages={Math.ceil(this.state.totalCourses / this.state.limit)}
                onChangePage={page => this.setState({ page })}
                siblingCount={2}
              />
            </Col>
          </div>
        </div>
      </div>
    );
  }
}

export default Courses;



// WEBPACK FOOTER //
// ./src/views/Courses/Courses.jsx